<template lang="pug">
  .height-100

    .box
      .title Links importantes
      loading(v-if="isLoading")
      div(v-else-if="lista.length === 0 && !isLoading")
        .message.is-warning
          .message-body No hay links importantes ingresados


      .display-flex
        div.p-10.pt-20
          ol
            li.cursor-pointer.text-left.transition-quick.mb-8(
              v-for="(o, index) in lista"
            )
              a(:href="o.ruta", target="_blank") {{ o.descripcion }}

</template>

<script>
import { apiGet, notify } from '../util/general'

export default {
  name: 'links-importantes',
  data () {
    return {
      lista              : [],
      isLoading          : false,
      idSeleccionado     : null,
      rutaSeleccionada   : null
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true

      var obj = {
        activo: 1
      }

      apiGet(vm, '/links-importantes', obj, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    seleccionar (o) {
      var vm = this
      vm.idSeleccionado = o.id
      vm.rutaSeleccionada = o.ruta
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  .selected
    font-weight bold
    color #3a4dc7

  .transition-quick
    transition: all .15s ease;

  .height-calculado
    height calc(100vh - 179px)

  .title
    font-size 16px
    font-weight bold
    text-transform uppercase
@media (max-width: 820px)
  .mb-8
    margin-bottom 8px

</style>




// WEBPACK FOOTER //
// View_Links_Importantes.vue?71513772